
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

export interface ChangeOption {
    status: number,
    target: any
}

/**
 * 
 * @prop   value    新闻列表数据  
 * @emit   delete   删除新闻
 * 
*/
@Component({
    name: 'recommend-table'
})
export default class extends Vue {
    @Prop({ required: true }) private value!: any[]

    @Emit('delete')
    private onDelete(news: any) {
        return news
    }
}
